export const FormCreateDataElectric = {
  id: null,
  name: null,
  name_touched: false,
  konversi_pln: null,
  konversi_pln_touched: false,
  active: false,
  is_file: false,
  is_unit: false,
  description_file: null,
  description_file_touched: false,
  description_unit: null,
  description_unit_touched: false,
  deleted: false,
  duplicate: false,
  is_touched: false,
  action: null,
};

export const FormValidasiDataElectric = {
  name: [(v) => !!v?.trim() || "Nama harus diisi"],
  konversi_pln: [
    (v) => !!v?.trim() || "Konfersi pln harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Konfersi pln tidak boleh berakhir dengan koma.",
  ],
  description_file: [
    (v) => !!v?.trim() || "Deskripsi file harus diisi",
  ],
  description_unit: [
    (v) => !!v?.trim() || "Deskripsi unit harus diisi",
  ],
};
